import { Calendar } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Расписание (АДМ-10, АДМ-12, АДМ-13, АДМ-15; матрица 2.2 «Расписание врачей»: OWNER, OPS_DIR, FRONT_DESK —
 * изменение; MED_DIR, HR — чтение; DOCTOR — своё). Вкладки — вложенные адреса (чек-лист запуска ведёт на /schedule/doctors).
 */
export const section = defineSection({
  id: 'schedule.calendar',
  area: 'clinic',
  path: 'schedule/*',
  roles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'DOCTOR', 'FRONT_DESK', 'HR'],
  icon: Calendar,
  titleKey: 'schedule:title',
  namespaces: ['portal', 'patients'],
  navGroup: 'work',
  order: 50,
  navRoles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'FRONT_DESK', 'HR'],
  load: () => import('./SchedulePage'),
});
